import React from "react";
import PropTypes from "prop-types";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import utils from "@utils";
import { Tooltip } from "../../../../components";
import { SettingsCard, RadioWithTooltip } from "../../ui";
import "./AuthenticationSection.scss";

const AuthenticationSection = props => {
	const {
		id,
		sectionRef,
		title,
		subtitle,
		mfaEnforced,
		federatedDomain,
		federationEnabled,
		federationEnforcedBy,
		handleFederationEnforcementDateChange,
	} = props;
	const { lang } = global;
	const {
		flags: { federation: federationFlag },
	} = props;
	const federationEnforced = federationEnforcedBy !== null;

	const handleFederationOff = () => {
		handleFederationEnforcementDateChange(null);
	};

	const handleFederationOn = () => {
		handleFederationEnforcementDateChange(utils.monthsFromNow(1).toISOString());
	};

	const handleFederationDateChange = e => {
		handleFederationEnforcementDateChange(utils.dateTimeLocalValueToIsoString(e.target.value));
	};

	return (
		<SettingsCard
			id={id}
			sectionRef={sectionRef}
			title={title}
			subtitle={subtitle}
		>
			<div className="standard-padding row lea-option">
				<div className="col-xs-12 form-group">
					<label htmlFor="mfa-enforced">
						<input
							type="checkbox"
							name="mfa-enforced"
							id="mfa-enforced"
							checked={mfaEnforced}
							disabled
						/>
						{lang.t("Authentication Section 2FA Option")}
						<Tooltip content={lang.t("Authentication Section 2FA Option Tooltip")}>
							<i className="hidden-xs rkf rkf-question-solid tooltip-icon" />
						</Tooltip>
					</label>
				</div>
			</div>

			<If condition={federationFlag}>
				<Choose>
					<When condition={federationEnabled}>
						<div className="federation-subsection">
							<div className="standard-padding row">
								<div className="col-xs-12">
									{lang.t("Authentication Section Federation Option")}
								</div>
							</div>
							<div className="standard-padding row">
								<RadioWithTooltip
									id="federation-not-enforced"
									name="federation-options"
									label={lang.t(
										"Authentication Section Federation Option Not Enforced",
									)}
									tooltipMessage={lang.t(
										"Authentication Section Federation Option Not Enforced Tooltip",
									)}
									checked={!federationEnforced}
									handleChange={handleFederationOff}
								/>
								<RadioWithTooltip
									id="federation-enforced"
									name="federation-options"
									checked={federationEnforced}
									label={lang.t(
										"dynamic.Authentication Section Federation Option Enforced",
										{ domain: federatedDomain },
									)}
									tooltipMessage={lang.t(
										"Authentication Section Federation Option Enforced Tooltip",
									)}
									handleChange={handleFederationOn}
								/>
								<If condition={federationEnforced}>
									<div className="col-xs-10 col-xs-offset-2 col-sm-11 subcategory-margin">
										<h4
											className="text-muted"
											style={{ fontSize: "14px" }}
										>
											{lang.t(
												"Authentication Section Federation Option Enforced Set Date",
											)}
										</h4>
										<p>
											{lang.t(
												"Authentication Section Federation Option Enforced Date Input Text",
											)}
											<input
												type="datetime-local"
												name=""
												id=""
												value={utils.utcDateStringToDateTimeLocalValue(
													federationEnforcedBy,
												)}
												onChange={handleFederationDateChange}
											/>
										</p>
									</div>
								</If>
							</div>
						</div>
					</When>
					<Otherwise>
						<div className="standard-padding row lea-option">
							<div className="col-xs-12 form-group">
								<label htmlFor="federation">
									<input
										type="checkbox"
										name="federation"
										id="federation"
										checked={false}
										disabled
									/>
									{lang.t("Authentication Section Federation Option Disabled")}
									<Tooltip
										content={lang.t(
											"Authentication Section Federation Option Disabled Tooltip",
										)}
									>
										<i className="hidden-xs rkf rkf-question-solid tooltip-icon" />
									</Tooltip>
								</label>
							</div>
						</div>
					</Otherwise>
				</Choose>
			</If>
		</SettingsCard>
	);
};

AuthenticationSection.propTypes = {
	id: PropTypes.string.isRequired,
	sectionRef: PropTypes.any.isRequired,
	title: PropTypes.string.isRequired,
	subtitle: PropTypes.string.isRequired,
	mfaEnforced: PropTypes.bool.isRequired,
	federationEnabled: PropTypes.bool.isRequired,
	federatedDomain: PropTypes.string,
	federationEnforcedBy: PropTypes.string,
	flags: PropTypes.object.isRequired,
	handleFederationEnforcementDateChange: PropTypes.func.isRequired,
};

AuthenticationSection.defaultProps = {
	federationEnforcedBy: null,
	federatedDomain: "",
};

export default withLDConsumer()(AuthenticationSection);
